import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchUserActivityLogList = (
    options?: UseMutationOptions<any, any, any, any>
) => {
    return useMutation(async (data: any) => {

        let url = `useractivitylog/list?searchFilter=${data.searchFilter}`
            + `&pageNumber=${data.pageNumber}`
            + `&pageSize=${data.pageSize}`;
        if (data.userId) {
            url += `&userId=${data.userId}`;
        }

        return await get(url);
    }, options);
};
